import React, {Component} from 'react';
import { Header, Modal } from 'semantic-ui-react'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import Moment from 'moment';
import GiornoSelect from './GiornoSelect'
import CommesseSelect3 from '../commesse/CommessaSelect3'
import AttivitaCorrente from './AttivitaCorrente'
import AttivitaNotification from './AttivitaNotification'
import AttivitaCompletate from './AttivitaCompletate'
import AttivitaForm from './AttivitaForm'
import AttivitaSovrappostaForm from './AttivitaSovrappostaForm'
import AttivitaGiorniPrecedentiColored from './AttivitaGiorniPrecedentiColored'
import AttivitaGiorniPrecedentiNonChiuse from './AttivitaGiorniPrecedentiNonChiuse'
import AttivitaRiepilogoOrarioCircolare from './AttivitaRiepilogoOrarioCircolare'
import LocalDate from '../LocalDate'
import {createInstance} from '../../Helpers';
import '../../styles/AttivitaUserContainer.css'
import PropTypes from 'prop-types';
class AttivitaUserContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userId: client.getCurrentUserId(),
            attivitaComplete: [],
            attivitaCorrente: undefined,
            attivitaPrecedente: undefined,
            nota: undefined,
            inizio: undefined,
            giorno: Moment().format("YYYY-MM-DD"),
            commessa: undefined,
            commesseAttive: [],
            _loading: false,
            error: null,
            imgRiepilogoOrario: undefined,
        };
        this.storeInstance = createInstance();
        this.loadData = this.loadData.bind(this)
        this.onChangeGiorno = this.onChangeGiorno.bind(this)
        this.onChangeCommessa = this.onChangeCommessa.bind(this)
        this.onAttivitaCorrenteChanged = this.onAttivitaCorrenteChanged.bind(this)
        this.onDeleteAttivitaClick = this.onDeleteAttivitaClick.bind(this)
        this.onNuovaAttivita = this.onNuovaAttivita.bind(this)
        this.onRiattivaAttivita = this.onRiattivaAttivita.bind(this)
        this.onOrarioClick = this.onOrarioClick.bind(this)
        this.onEditAttivita = this.onEditAttivita.bind(this)
        this.onEditAttivitaEnd = this.onEditAttivitaEnd.bind(this)
        this.onSovrapponiAttivita = this.onSovrapponiAttivita.bind(this)
        this.onSovrapponiAttivitaEnd = this.onSovrapponiAttivitaEnd.bind(this)
        this.onRiepilogoOrarioChartUpdated = this.onRiepilogoOrarioChartUpdated.bind(this)
    }

    componentWillUnmount() {
        if (this.storeInstance ){
            this.storeInstance.save('attivitausercontainer', this.state);
        }

    }

    componentDidMount() {
        if (this.storeInstance && this.storeInstance.restore('attivitausercontainer', this , () => {
                this.loadData();
                this.loadCommesseAttive();
            }) === null){
            this.loadData();
            this.loadCommesseAttive();
        }
    }

    onDeleteAttivitaClick(ev, attivita){
        this.setState({_loading: true});
        client.deleteAttivita(attivita).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.loadData()
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    onRiepilogoOrarioChartUpdated(img){
        this.setState({imgRiepilogoOrario: img})
    }

    onNuovaAttivita(attivita) {

        if (attivita !== undefined){
            let inizio = Moment(attivita.fine).format("HH:mm");
            let commessa = attivita.idCommessa;
            let giorno = Moment(attivita.giorno).format("YYYY-MM-DD");
            let nota = attivita.nota;

            this.setState({
                attivitaCorrente: undefined,
                giorno: giorno,
                commessa: commessa,
                nota: nota,
                inizio: inizio,
                _loading: false,
                error: null
            })

        }
    }

    // Vecchia versione: inserisce l'attività da completare
    // Modificata da Emanuele 05/05/2020
    // onNuovaAttivita(attivita){
    //     console.log("Nuova attività");
    //     if (attivita !== undefined){
    //
    //         let inizio = Moment().format("HH:mm");
    //         let itemPrev = this.state.attivitaPrecedente;
    //         if (itemPrev !== undefined && itemPrev.fine !== null) {
    //             inizio = Moment(itemPrev.fine).format("HH:mm");
    //         }
    //
    //         let fields = {
    //             idCommessa: attivita.idCommessa.idCommessa,
    //             giorno: Moment(attivita.giorno).format("YYYY-MM-DD"),
    //             inizio: Moment(attivita.giorno).format("YYYY-MM-DD") + ' ' + inizio,
    //             nota: attivita.nota,
    //             peson: 1,
    //             pesod: 1,
    //             idUtente: client.getCurrentUserId(),
    //         }
    //
    //         this.setState({_loading: true});
    //         client.saveAttivita(
    //             fields
    //         ).then((response) => {
    //             if (response.ok){
    //                 response.json().then((data) => {
    //                     this.setState({
    //                         _loading: false,
    //                         error: null,
    //                     });
    //                     this.loadData();
    //                 })
    //             }
    //             else if (response.status === 401)
    //             {
    //                 this.props.history.push("/login")
    //             }
    //             else
    //             {
    //                 response.json().then((errore) => {
    //                     this.setState({
    //                         _loading: false,
    //                         error: {title: errore.title, msg: errore.msg},
    //                     });
    //                 })
    //             }
    //         }).catch((error) => {
    //             this.setState({
    //                 _loading: false,
    //                 error: {title: "Errore di rete imprevisto", msg: error.message},
    //             });
    //         });
    //     }
    // }

    onOrarioClick(orario){
        this.setState({inizio: Moment(orario).format("HH:mm")});
    }
    onRiattivaAttivita(attivita){

        if (attivita !== undefined){

            let fields = {
                idCommessa: attivita.idCommessa.idCommessa,
                giorno: Moment(attivita.giorno).format("YYYY-MM-DD"),
                inizio: Moment(attivita.giorno).format("YYYY-MM-DD") + ' ' + Moment(attivita.inizio).format("HH:mm"),
                fine: '',
                nota: attivita.nota,
                peson: attivita.peson,
                pesod: attivita.pesod,
                idUtente: client.getCurrentUserId(),
            }

            this.setState({_loading: true});
            client.updateAttivita(
                fields, attivita.idAttivita
            ).then((response) => {
                if (response.ok){
                    response.json().then((data) => {
                        this.setState({
                            _loading: false,
                            error: null,
                        });
                        this.loadData();
                    })
                }
                else if (response.status === 401)
                {
                    this.props.history.push("/login")
                }
                else
                {
                    response.json().then((errore) => {
                        this.setState({
                            _loading: false,
                            error: {title: errore.title, msg: errore.msg},
                        });
                    })
                }
            }).catch((error) => {
                this.setState({
                    _loading: false,
                    error: {title: "Errore di rete imprevisto", msg: error.message},
                });
            });
        }
    }

    onEditAttivita(attivita, precedente, successiva){
        this.setState({editAttivita: {attivita, precedente, successiva}})

    }
    onEditAttivitaEnd(attivita){
        this.setState({editAttivita: undefined})
        if (attivita !== undefined){
            let attivitaComplete = this.state.attivitaComplete.map((att) => {
                if (att.idAttivita === attivita.idAttivita){
                    return attivita;
                }
                return att
            })
            if (this.state.attivitaPrecedente !== undefined && this.state.attivitaPrecedente.idAttivita === attivita.idAttivita){
                this.setState({attivitaComplete: attivitaComplete, attivitaPrecedente: attivita});
            }
            else
            {
                this.setState({attivitaComplete: attivitaComplete});
            }

        }
    }

    onSovrapponiAttivita(attivita, precedente, successiva){
        this.setState({editAttivitaSovrapposta: {attivita, precedente, successiva}})
    }

    onSovrapponiAttivitaEnd(attivitaOriginale, attivitaNuova){
        this.setState({editAttivitaSovrapposta: undefined})
        if (attivitaOriginale !== undefined && attivitaNuova !== undefined){
            let attivitaComplete = [];

            this.state.attivitaComplete.forEach((att) => {
                if (att.idAttivita === attivitaOriginale.idAttivita){
                    attivitaComplete.push(attivitaOriginale);
                    attivitaComplete.push(attivitaNuova);
                }
                else {
                    attivitaComplete.push(att);
                }
            })
            if (this.state.attivitaPrecedente !== undefined && this.state.attivitaPrecedente.idAttivita === attivitaOriginale.idAttivita){
                this.setState({attivitaComplete: attivitaComplete, attivitaPrecedente: attivitaOriginale});
            }
            else
            {
                this.setState({attivitaComplete: attivitaComplete});
            }

        }
    }

    loadCommesseAttive(){
        this.setState({ _loading: true });
        client.loadCommesseNonChiuseList().then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        _loading: false,
                        error: null,
                        commesseAttive: data.items
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.setState({
                _loading: false,
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    loadData() {
        this.setState({_loading: true});
        client.loadAttivitaUtente(this.state.userId, this.state.giorno).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{

                    let completate = data.items.filter((item)=>{
                        return (item.fine !== null);
                    })

                    let corrente = data.items.filter((item)=>{
                        return item.fine === null;
                    })
                    if (corrente.length > 0){
                        corrente = corrente[0];
                    }
                    else {
                        corrente = undefined;
                    }
                    let precedente = undefined;
                    if (completate.length > 0){
                        precedente = completate[completate.length - 1];
                    }
                    this.setState({
                        attivitaComplete: completate,
                        attivitaCorrente: corrente,
                        attivitaPrecedente: precedente,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });

    }

    onChangeGiorno(giorno){
        this.setState({giorno: giorno, inizio: undefined, nota: undefined}, ()=>{
            this.loadData();
        })


    }

    onAttivitaCorrenteChanged(){
        this.setState({commessa: undefined, inizio: undefined, nota: undefined}, () => {
            this.loadData();
        })
    }

    onChangeCommessa(commessa){
        this.setState({inizio: undefined, nota: undefined}, ()=>{
            this.setState({commessa: commessa})
        });

    }

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        // let loader = '';
        // if  (this.state._loading) {
        //     loader = (
        //         <div className="ui active inverted dimmer">
        //         <div className="ui loader"></div>
        //         </div>
        //     );
        // }

        let editAttivita = null;
        if (this.state.editAttivita !== undefined){
            editAttivita = (<Modal
                    open={this.state.editAttivita !== undefined}
                >
                    <Header icon='edit' content='Modifica Attività' />
                    <Modal.Content>

                        <AttivitaForm
                            item={this.state.editAttivita.attivita}
                            giorno={this.state.giorno}
                            commesseList={this.state.commesseAttive}
                            onUndoClick={this.onEditAttivitaEnd}
                            onSaveClick={this.onEditAttivitaEnd}
                        />

                    </Modal.Content>
                </Modal>)
        } else if (this.state.editAttivitaSovrapposta !== undefined){
            editAttivita = (<Modal
                open={this.state.editAttivitaSovrapposta !== undefined}
            >
                <Header icon='edit' content='Sovrapponi Attività' />
                <Modal.Content>

                    <AttivitaSovrappostaForm
                        itemSource={this.state.editAttivitaSovrapposta.attivita}
                        giorno={this.state.giorno}
                        commessa={this.state.commessa}
                        commesseList={this.state.commesseAttive}
                        onUndoClick={this.onSovrapponiAttivitaEnd}
                        onSaveClick={this.onSovrapponiAttivitaEnd}
                    />

                </Modal.Content>
            </Modal>)
        }

        let attivitaCorrente = <AttivitaCorrente
            item={this.state.attivitaCorrente}
            itemPrev={this.state.attivitaPrecedente}
            giorno={this.state.giorno}
            commessa={this.state.commessa}
            nota={this.state.nota}
            inizio={this.state.inizio}
            onChange={this.onAttivitaCorrenteChanged}
            onDeleteClick={this.onDeleteAttivitaClick}
        />;

        let attivitaRunning = this.state.attivitaCorrente !== undefined;

        return (<div className="ui">
            <div className="ui two column stackable grid">

                <div className="row">
                <div className="four wide column">
                    <div className="ui segment">

                        <div className="ui fluid card">
                        <GiornoSelect giorno={this.state.giorno} onChange={this.onChangeGiorno}/>
                        </div>

                            <CommesseSelect3
                                onChange={this.onChangeCommessa}
                                fluid="true"
                                compact="true"
                                commessa={this.state.commessa}
                                commesseList={this.state.commesseAttive}
                            />

                    </div>


                </div>
                <div className="twelve wide column">

                    <AttivitaGiorniPrecedentiNonChiuse
                        giorno={this.state.giorno}
                        idUtente={this.state.userId}
                        numgg={30}
                        onClickGiorno={this.onChangeGiorno}
                    />

                    {attivitaRunning ? null : attivitaCorrente}

                    <div className="ui two column stackable grid">
                        <div className="eleven wide column">
                            <div className="ui segments">
                                <div className="ui secondary segment">
                                    <p>Attività del <LocalDate data={this.state.giorno}/></p>
                                </div>

                                {attivitaRunning ? attivitaCorrente : null}

                                <AttivitaCompletate
                                items={this.state.attivitaComplete}
                                giorno={this.state.giorno}
                                onDeleteClick={this.onDeleteAttivitaClick}
                                onEditAttivita={this.onEditAttivita}
                                onSovrapponiAttivita={this.onSovrapponiAttivita}
                                onNuovaAttivita={this.onNuovaAttivita}
                                onRiattivaAttivita={this.onRiattivaAttivita}
                                onOrarioClick={this.onOrarioClick}
                                attivitaRunning={attivitaRunning}
                                loading={this.state._loading}
                                showProgress={false}
                            />

                            </div>

                        </div>
                        <div className="five wide column">
                            <AttivitaRiepilogoOrarioCircolare
                                giorno={this.state.giorno}
                                idUtente={this.state.userId}
                                attivitaCorrente={this.state.attivitaCorrente}
                                attivitaComplete={this.state.attivitaComplete}
                                message={this.state.attivitaCorrente !== undefined ? this.state.attivitaCorrente.idCommessa.codice : ''}
                                onChartUpdated={this.onRiepilogoOrarioChartUpdated}
                                maxSovrapposizioni={8}
                            />

                            {/*<AttivitaRiepilogoOrario*/}
                                {/*giorno={this.state.giorno}*/}
                                {/*idUtente={this.state.userId}*/}
                                {/*attivitaCorrente={this.state.attivitaCorrente}*/}
                                {/*attivitaComplete={this.state.attivitaComplete}*/}
                                {/*message={this.state.attivitaCorrente !== undefined ? 'Registrazione in corso:' + this.state.attivitaCorrente.idCommessa.codice : 'Nessuna attività:in esecuzione'}*/}
                                {/*onChartUpdated={this.onRiepilogoOrarioChartUpdated}*/}
                            {/*/>*/}
                        </div>
                    </div>
                    {/*<div className="ui segments">*/}
                        {/*<div className="ui secondary segment">*/}
                            {/*<p>Riepilogo odierno per Commessa</p>*/}
                        {/*</div>*/}
                        {/*<div className="ui segment">*/}
                            {/*<AttivitaRiepilogoCommessa*/}
                                {/*giorno={this.state.giorno}*/}
                                {/*idUtente={this.state.userId}*/}
                            {/*/>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                    {/*<AttivitaRiepilogoOrarioOriz*/}
                        {/*giorno={this.state.giorno}*/}
                        {/*idUtente={this.state.userId}*/}
                        {/*attivitaCorrente={this.state.attivitaCorrente}*/}
                        {/*attivitaComplete={this.state.attivitaComplete}*/}
                        {/*message={this.state.attivitaCorrente !== undefined ? 'Registrazione in corso:' + this.state.attivitaCorrente.idCommessa.codice : 'Nessuna attività:in esecuzione'}*/}
                        {/*onChartUpdated={this.onRiepilogoOrarioChartUpdated}*/}
                        {/*canvasRowHeight={50}*/}
                    {/*/>*/}
                    <div className="ui segments">
                        <div className="ui secondary segment">
                            <p>Attivita registrate nei 7 giorni precedenti</p>
                        </div>
                        <AttivitaGiorniPrecedentiColored
                            giorno={this.state.giorno}
                            idUtente={this.state.userId}
                            numgg={7}
                            onClickGiorno={this.onChangeGiorno}
                        />
                    </div>

                </div>
                </div>
            </div>
            {editAttivita}
            {/*{loader}*/}
            <AttivitaNotification
                attivitaCorrente={this.state.attivitaCorrente}
                attivitaPrecedente={this.state.attivitaPrecedente}
                attivitaComplete={this.state.attivitaComplete}
                giorno={this.state.giorno}
                commessa={this.state.commessa}
                attive={true}
                imageContent={this.state.imgRiepilogoOrario}
            />
        </div>)
    }
}

AttivitaUserContainer.contextTypes = {
    router: PropTypes.object
}


export default AttivitaUserContainer;




/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaUserContainer.js
 **/